import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {provideStoreDevtools} from '@ngrx/store-devtools';

// We don't have a consolidated Environment type for Hawk/Phoenix yet.  When we do (and define it in Aviary), we can use that and remove this.
export interface MinimalEnvironment {
  readonly name: string;
  readonly app: string;
  readonly production: boolean;
}

export function provideAviaryStoreDevtools(environment: MinimalEnvironment): EnvironmentProviders {
  return makeEnvironmentProviders(
    environment.production
      ? []
      : [
        provideStoreDevtools({
          name: `${environment.app} (${environment.name})`, // Helps identify the right instance to view from the browser interface.
          maxAge: 25, // Number of states to retain.
          autoPause: true, // Pauses recording actions and state changes when the extension window is not open.
          trace: false, // If set to true, will include stack trace for every dispatched action, so you can jump directly to code from the trace tab.
          traceLimit: 75, // Maximum stack trace frames to be stored (when the trace option is true).
          connectInZone: true // Run the Devtools connection in Angular's zone so time travel/manual dispatches update the UI reliably.
        })
      ]
  );
}
